export default __webpack_public_path__ + "static/media/realization.a2f49b26.svg";